import PessoaService from "business/cadastro/pessoa/pessoa/pessoaService"
import { isValidCnpj } from "helper/checker"
import { boolToNumber, jsDateToLuxonString, toJSDate, toJSDatetime } from "helper/formater"
import { justNumbers } from "helper/parser"
import * as yup from "yup"

export default class PessoaJuridicaService extends PessoaService {

    title = "Pessoa jurídica"
    pluralTitle = "Pessoas jurídicas"
    url = '/cadastro/pessoa/pessoajuridica'
    frontUrl = '/cadastro/pessoa/pessoajuridica'
    frontUrlList = '/cadastro/pessoa/pessoajuridicalist'
    primaryKey = 'codigo_pej'
    ignoredsSchemaConvertions = ['cod_regit_pej', 'cod_regite_pej', 'cod_rati_pej', 'cod_grup_pes', 'cod_catp_pes', 'cod_clap_pes']
    // icon = 'pi pi-verified'

    postDTO(data = {}) {

        data.pessoa.tel_cel_pes = justNumbers(data.pessoa.tel_cel_pes)
        data.pessoa.tel_comercial_pes = justNumbers(data.pessoa.tel_comercial_pes)

        return data

    }
    prepareToFront(data = {}) {

        console.log('prepareToFront()', data)

        // Garante a presença de pessoa e pessoa_endereco no Novo
        data.pessoa = data.pessoa || {}

        data.cnpj_ativo_pej = boolToNumber(data.cnpj_ativo_pej)
        data.forn_pej = boolToNumber(data.forn_pej)
        data.mva_icms_esp_pej = boolToNumber(data.mva_icms_esp_pej)
        data.conveniado_pej = boolToNumber(data.conveniado_pej)
        data.reter_picocs_pej = boolToNumber(data.reter_picocs_pej)
        data.pessoa.reter_iss_pes = boolToNumber(data.pessoa.reter_iss_pes)
        data.ince_fiscal_pej = boolToNumber(data.ince_fiscal_pej)
        data.ince_cult_pej = boolToNumber(data.ince_cult_pej)

        data.pessoa.pessoa_endereco = data.pessoa?.pessoa_endereco || []
        data.pessoa.cli_atac_pes = data.pessoa.cli_atac_pes || 0
        data.pessoa.blq_venda_ate_pes = toJSDatetime(data.pessoa.blq_venda_ate_pes)
        data.fundacao_pej = toJSDate(data.fundacao_pej)

        if (data.pessoa?.pessoa_endereco) {
            data.pessoa.pessoa_endereco.forEach(e => {
                e.usa_desde_ende = toJSDate(e.usa_desde_ende)
            })
        }

        return data
    }

    async getById(args = {}) {

        args.includes = args.includes || 'main,pessoa_endereco_tipo'
        return super.getById(args).then((response) => {
            console.log("outro aqui")
            // response.data = this.prepareToFront(response.data)
            console.log('BACKEND: ', response)
            return response
        })

    }

    prepareToSave({ data }) {

        data.cod_regit_pej = data.cod_regit_pej?.codigo_regit || null
        data.cod_regite_pej = data.cod_regite_pej?.codigo_regit || null
        data.cod_rati_pej = data.cod_rati_pej?.codigo_rati || null

        data.forn_pej = boolToNumber(data.forn_pej)

        data.cnpj_ativo_pej = boolToNumber(data.cnpj_ativo_pej, true)
        data.mva_icms_esp_pej = boolToNumber(data.mva_icms_esp_pej)
        data.conveniado_pej = boolToNumber(data.conveniado_pej)
        data.reter_picocs_pej = boolToNumber(data.reter_picocs_pej)
        data.pessoa.reter_iss_pes = boolToNumber(data.pessoa.reter_iss_pes)
        data.ince_fiscal_pej = boolToNumber(data.ince_fiscal_pej)
        data.ince_cult_pej = boolToNumber(data.ince_cult_pej)

        data.pessoa.blq_venda_ate_pes = jsDateToLuxonString(data.pessoa.blq_venda_ate_pes)

        data.pessoa.reter_iss_pes = boolToNumber(data.pessoa.reter_iss_pes)
        data.pessoa.cli_atac_pes = boolToNumber(data.pessoa.cli_atac_pes)

        data.pessoa.cod_grup_pes = data.pessoa.cod_grup_pes?.codigo_grup || null
        data.pessoa.cod_catp_pes = data.pessoa.cod_catp_pes?.codigo_catp || null
        data.pessoa.cod_clap_pes = data.pessoa.cod_clap_pes?.codigo_clap || null

        data.pessoa.email_fina_pes = data.pessoa.email_fina_pes || null

        data.pessoa.pessoa_endereco.forEach(e => {
            e.cod_tend_ende = e.cod_tend_ende.codigo_tend
            e.cod_muni_ende = e.cod_muni_ende.codigo_muni
        })

        delete data.meta

        return data

    }

    async getSchema() {

        return super.getSchema().then((data) => {

            if (data.fields.pessoa.fields) {

                data.fields.pessoa.fields.cpf_cnpj_pes = data.fields.pessoa.fields.cpf_cnpj_pes.test('cnpj', 'Cnpj incorreto!', isValidCnpj)
                data.fields.pessoa.fields.pessoa_endereco.innerType.fields.cod_tend_ende = yup.object().typeError('Obrigatório').required('Obrigatório')
                data.fields.pessoa.fields.pessoa_endereco.innerType.fields.cod_muni_ende = yup.object()
                    .test('municipio', 'Inválido', e => e.codigo_muni)
                    .typeError('Obrigatório')
                    .required('Obrigatório')

            }

            return data

        })

    }

}
